export interface AuthTokens {
  accessToken: string;
}

export async function googleLogin(accessToken: string): Promise<AuthTokens> {
  const res = await fetch('/api/auth/google', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ accessToken }),
  });

  if (!res.ok) throw new Error('Google 로그인에 실패했습니다.');
  return res.json() as Promise<AuthTokens>;
}

export async function refreshAccessToken(): Promise<AuthTokens | null> {
  const res = await fetch('/api/auth/refresh', {
    method: 'POST',
  });

  if (!res.ok) return null;
  return res.json() as Promise<AuthTokens>;
}

export async function logout(): Promise<void> {
  await fetch('/api/auth/logout', {
    method: 'POST',
  });
}
